const ja: Record<string, string> = {
  loading: "読み込み中...",
  loadingDashboard: "ダッシュボードを読み込み中...",
  loadingDates: "日付を読み込み中...",
  loadingSlots: "時間枠を読み込み中...",
  redirecting: "リダイレクト中...",
  authenticating: "認証中...",
  saving: "保存中...",
  savingEllipsis: "保存中...",
  pleaseWait: "お待ちください...",
  pleaseWaitSignIn: "サインインを完了しています...",
  failed: "失敗しました",
  failedToLoadSchedule: "スケジュールの読み込みに失敗しました",
  failedToLoadSettings: "設定の読み込みに失敗しました",
  sessionExpired: "セッションが期限切れです",
  apiError: "APIエラー: {status}",
  rescheduleFailed: "変更に失敗しました",
  authFailed: "認証に失敗しました",
  authFailedTitle: "認証失敗",
  missingAuthCode: "認証コードまたはステートが見つかりません。",
  invalidState: "無効なステートパラメータです。再度ログインしてください。",
  loginInitFailed: "ログインの初期化に失敗しました。再度お試しください。",
  popupBlocked: "ポップアップがブロックされました。このサイトのポップアップを許可して再度お試しください。",
  loginWindowClosed: "ログインウィンドウが閉じられました。",
  accessDenied: "アクセスが拒否されました。アカウントに管理者権限がありません。管理者にお問い合わせください。",
  accountDeactivated: "このアカウントは無効化されています。管理者にお問い合わせください。",
  yourAccount: "アカウント設定",
  failedOpenLogin: "ログインウィンドウを開けませんでした。",
  bookingRescheduled: "予約の変更が完了しました",
  companySettingsSaved: "店舗設定を保存しました",
  bookingPoliciesSaved: "予約ポリシーを保存しました",
  scheduleSaved: "スケジュールを保存しました",
  lineConfigSaved: "LINE設定を保存しました",
  staffCreated: "スタッフを追加しました",
  staffUpdated: "スタッフ情報を更新しました",
  staffActivated: "スタッフを有効にしました",
  staffDeactivated: "スタッフを無効にしました",
  notifySettingSaved: "通知設定を保存しました",
  orderSaved: "並び順を保存しました",
  serviceCreated: "サービスを追加しました",
  serviceUpdated: "サービスを更新しました",
  serviceActivated: "サービスを有効にしました",
  serviceDeactivated: "サービスを無効にしました",
  unavailabilityAdded: "対応不可時間を追加しました",
  unavailabilityRemoved: "対応不可時間を削除しました",
  bookingCancelled: "予約をキャンセルしました",
  bookingCompleted: "予約を完了にしました",
  deactivateServiceConfirm: "このサービスを無効にしますか？",
  deactivateStaffConfirm: "このスタッフを無効にしますか？",
  markCompleted: "完了にする",
  completeBookingConfirm: "この相談を完了にしますか？",
  cancelBookingConfirm: "この予約をキャンセルしますか？",
  removeBlockConfirm: "この休止日を削除しますか？",
  yes: "はい",
  no: "いいえ",
  dashboard: "ダッシュボード",
  services: "サービス",
  staff: "スタッフ",
  bookings: "予約一覧",
  calendar: "カレンダー",
  reschedules: "変更履歴",
  logs: "ログ",
  users: "ユーザー",
  settings: "設定",
  logout: "ログアウト",
  viewSite: "サイトを見る",
  language: "言語",
  bookingAdmin: "管理",
  adminDesc: "予約管理ダッシュボード",
  addService: "サービス追加",
  addStaff: "スタッフ追加",
  saveCompanyInfo: "店舗情報を保存",
  companyLogo: "会社ロゴ",
  companyLogoHelp: "お客様の予約ページに表示されます。PNG・JPEG・WebP、最大5MB。",
  uploadLogo: "ロゴをアップロード",
  replaceLogo: "ロゴを変更",
  removeLogo: "ロゴを削除",
  logoSaved: "ロゴを保存しました",
  logoRemoved: "ロゴを削除しました",
  saveBookingPolicies: "予約ポリシーを保存",
  saveLineConfig: "LINE設定を保存",
  saveSchedule: "スケジュールを保存",
  createRichMenu: "リッチメニューを作成",
  configureLine: "LINE設定",
  signIn: "認証サービスでサインイン",
  allStatuses: "すべてのステータス",
  loginTitle: "管理",
  loginSubtitle: "ダッシュボードにサインイン",
  todayBookings: "本日の予約",
  totalBookings: "予約総数",
  upcoming: "予定",
  bookingsCount: "予約{n}件",
  activeUsers: "アクティブユーザー",
  pending: "未確認",
  totalRevenue: "売上合計",
  noBookingsToday: "本日の予約はありません",
  todayReschedules: "本日の予約変更",
  noReschedulesToday: "本日の変更はありません",
  noBookingsFound: "予約が見つかりません",
  noServicesYet: "サービスがまだありません",
  noStaffYet: "スタッフがまだありません",
  noUsersFound: "ユーザーが見つかりません",
  noReschedulesFound: "変更履歴がありません",
  noBlocks: "ブロックなし",
  noAvailableSlots: "この日付の予約可能枠がありません。",
  clickDateToView: "日付をクリックして予約を表示",
  noBookingsOnDate: "{date}の予約はありません",
  selectDate: "日付を選択",
  bookingCalendar: "予約カレンダー",
  rescheduleBooking: "予約日時変更",
  rescheduleBookingTitle: "日時変更",
  addServiceTitle: "サービス追加",
  editServiceTitle: "サービス編集",
  serviceCode: "サービスコード",
  serviceCodeHint: "予約URLに使用します。半角小文字英数で入力（例：posture, shoulder）",
  addStaffTitle: "スタッフ追加",
  editStaffTitle: "スタッフ編集",
  weeklySchedule: "週間スケジュール",
  addBreak: "休憩を追加",
  scheduleWeekSummary: "週{days}日勤務 · 週{hours}",
  dayOff: "休み",
  workingHours: "勤務時間",
  breakLabel: "休憩（予約不可）",
  removeBreak: "休憩を削除",
  scheduleEndAfterStart: "終了時刻は開始時刻より後にしてください",
  newBlock: "新しいブロック",
  addBlock: "ブロックを追加",
  setHours: "時間を指定",
  blockSummary: "今後{count}件",
  upcomingTab: "今後",
  pastTab: "過去",
  noUpcomingBlocks: "今後の不在ブロックはありません",
  noUpcomingBlocksHint: "上のフォームから終日または時間帯で不在を登録できます。",
  removeBlockConfirmDetail: "{when} の不在ブロックを削除しますか？",
  scheduleBreakInside: "休憩は勤務時間内に収めてください",
  bookable: "予約可能",
  copyToWorkingDays: "この時間を全勤務日にコピー",
  breakTime: "休憩（週間スケジュール）",
  unavailabilityBlocks: "不在ブロック",
  pastBlocks: "過去のブロック",
  noPastBlocks: "過去のブロックはありません",
  availableTimes: "予約可能時間",
  companyInformation: "店舗情報",
  bookingPolicies: "予約ポリシー",
  moreActions: "その他の操作",
  lineIntegration: "LINE連携",
  richMenu: "リッチメニュー",
  companyName: "店舗名",
  description: "説明",
  phone: "電話番号",
  email: "メールアドレス",
  address: "住所",
  timezone: "タイムゾーン",
  type: "タイプ：",
  durationMinutes: "所要時間（分）",
  priceYen: "料金（¥）",
  bio: "自己紹介",
  slotInterval: "スロット間隔（分）",
  bufferTime: "バッファ時間（分）",
  cancellationPolicy: "キャンセルポリシー（予約何時間前まで）",
  reminder24h: "24時間前リマインド",
  reminder1h: "1時間前リマインド",
  showSlotStaffCount: "時間枠にスタッフ人数を表示",
  showSlotStaffCountHelp: "予約画面の各時間枠に、予約可能なスタッフの人数を「空き2」のように表示します",
  showServiceDuration: "メニューの所要時間を表示",
  showServiceDurationHelp: "予約画面やLINEのメニューで、各メニューの所要時間（例: 60分）を表示します。オフにすると料金のみ表示され、予約枠の計算には影響しません",
  pointsSection: "ポイント",
  pointsStatusOn: "有効（還元率 {rate}%）",
  pointsStatusOff: "無効",
  pointsManagedInAuth: "ポイントは整骨院・ジムなど全アプリ共通の残高になり、設定は認証サービスの管理画面（OAuthクライアント）で行います。",
  openingSpecialSection: "オープン記念特別価格",
  openingSpecialEnabled: "オープン記念特別価格を適用する",
  openingSpecialHelp: "有効にすると、表示中の全メニューが下の価格になり、予約サイトにバナーと元の価格（取り消し線）が表示されます。無料のメニューや、この価格より安いメニューは変わりません。予約は予約時の価格で記録されるため、終了しても過去の予約の金額やポイントは変わりません",
  openingSpecialPrice: "特別価格（円）",
  openingSpecialPriceInvalid: "1円以上の整数で入力してください",
  openingSpecialSave: "特別価格を保存",
  openingSpecialSaved: "特別価格を保存しました",
  thPoints: "ポイント",
  pointsHistory: "ポイント履歴",
  pointsBalance: "残高",
  pointsEmpty: "まだポイントはありません。",
  selectableLengths: "お客様が所要時間を選べる",
  selectableLengthsHint: "オンにすると固定の所要時間ではなく、下で指定した中からお客様が選びます",
  bookingDurationOptions: "選べる所要時間（分）",
  bookingDurationOptionsHelp: "お客様がこのメニューを予約する際に選べる所要時間をカンマ区切りで指定します（例: 30, 60, 90）",
  bookingDuration: "所要時間",
  lineChannelId: "Messaging APIチャネルID",
  lineChannelSecret: "Messaging APIチャネルシークレット",
  lineChannelAccessToken: "Messaging APIチャネルアクセストークン（長期）",
  lineLoginChannelId: "LINEログインチャネルID",
  liffAppId: "LIFFアプリID",
  liffEndpointUrl: "LIFF エンドポイントURL",
  liffEndpointUrlHint: "LINE Developers コンソールの LINEログインチャネル → LIFF → 対象アプリ → エンドポイントURL に貼り付けてください。必ず上記のお客様用アプリを指定します。この管理画面のURLを指定すると、お客様に管理画面のログイン画面が表示されてしまいます。",
  slotIntervalHelp: "予約可能なスロット間の時間（例：30 → 9:00、9:30、10:00...）",
  bufferTimeHelp: "予約間の準備/片付け時間（次のスロットをブロック）",
  lineConfigDesc: "LINE公式アカウントのチャネルを設定して、メッセージ、リッチメニュー、LIFF連携を有効にします。",
  richMenuDesc: "LINE公式アカウントのデフォルトリッチメニューを作成します。すべてのLINEチャネルフィールドの設定が必要です。",
  lineDiagnose: "診断する",
  lineDiagnosing: "確認中...",
  lineDiagnoseDesc: "このチャネルアクセストークンがどのLINE公式アカウントを操作するのか、Webhookが正しく設定されているのかを確認します。",
  lineDiagnoseOk: "問題は見つかりませんでした。",
  lineConnectedOa: "接続中のLINE公式アカウント",
  chat: "チャット",
  emailUser: "メール",
  copy: "コピー",
  copied: "コピーしました",
  notFound: "顧客が見つかりません",
  lineChatMode: "応答モード",
  lineChatModeBot: "Bot",
  lineChatModeChat: "チャット（LINEが自動応答）",
  lineTokenChannel: "トークンのチャネル",
  lineConfiguredChannel: "設定中のチャネルID",
  lineTokenExpiry: "トークン有効期限",
  lineTokenExpiryDays: "あと{days}日",
  lineWebhookUrl: "Webhook URL",
  lineWebhookUrlHint: "LINE Developers コンソールの Messaging API → Webhook URL に貼り付け、「Webhookの利用」をオンにしてください。",
  lineWebhookExpected: "想定",
  lineWebhookUnset: "未設定",
  lineWebhookActive: "Webhook有効",
  lineWebhookTest: "Webhookテスト",
  lineWebhookTestOk: "成功",
  channelConfigured: "チャネル設定済み",
  channelNotConfigured: "未設定",
  liffIdSet: "LIFF ID設定済み",
  liffIdNotSet: "LIFF ID未設定",
  searchNamePhone: "名前または電話番号で検索...",
  placeholderStart: "開始",
  placeholderEnd: "終了",
  placeholderLineChannelId: "例：1234567890（Messaging APIチャネル）",
  placeholderLineLoginChannelId: "例：1234567890（LINEログインチャネル・LIFF認証用）",
  placeholderSecretSet: "設定済み — 変更しない場合は空欄",
  placeholderSecretUnset: "LINE Developers Consoleのチャネルシークレット",
  placeholderAccessTokenSet: "設定済み — 変更しない場合は空欄",
  placeholderAccessTokenUnset: "長期チャネルアクセストークン",
  placeholderLiffId: "例：1657890123-aBcDeFgH",
  thWhen: "日時",
  thSource: "経路",
  thDate: "日付",
  thTime: "時間",
  thNote: "メモ",
  thUser: "ユーザー",
  thService: "サービス",
  thStaff: "スタッフ",
  thStatus: "ステータス",
  thActions: "操作",
  thName: "名前",
  thDuration: "所要時間",
  thPrice: "料金",
  thCategory: "カテゴリ",
  thMethod: "方法",
  meetingMethodPHONE: "お電話",
  meetingMethodEMAIL: "メール",
  meetingMethodIN_PERSON: "対面",
  thJoined: "登録日",
  thRescheduledBy: "変更者",
  thOriginal: "変更前",
  thNew: "変更後",
  thRescheduledAt: "変更日時",
  active: "有効",
  inactive: "無効",
  cancelled: "キャンセル済み",
  noShow: "不来",
  confirmed: "確定",
  completed: "完了",
  allDay: "終日",
  actorUser: "ユーザー",
  prev: "前へ",
  next: "次へ",
  back: "戻る",
  tryAgain: "再試行",
  add: "追加",
  edit: "編集",
  cancel: "キャンセル",
  close: "閉じる",
  remove: "削除",
  search: "検索",
  create: "作成",
  update: "更新",
  activate: "有効化",
  deactivate: "無効化",
  reschedule: "日時変更",
  pagerRange: "{total} 件中 {shown} 件",
  bookingCount: "{count}件の予約",
  userCount: "{count}件のユーザー",
  sun: "日",
  mon: "月",
  tue: "火",
  wed: "水",
  thu: "木",
  fri: "金",
  sat: "土",
  min: "分",
  addBooking: "予約追加",
  addBookingTitle: "新規予約",
  addUser: "ユーザー追加",
  addUserTitle: "新規ユーザー",
  userCreated: "ユーザーを作成しました",
  userCreateFailed: "ユーザーの作成に失敗しました",
  userEmailRequired: "メールアドレスは必須です",
  userNameRequired: "名前は必須です",
  userPhoneInvalid: "0から始まる電話番号を入力してください（10〜11桁、例：09012345678）",
  phonePlaceholder: "例：09012345678",
  userEmailInvalid: "有効なメールアドレスを入力してください",
  userEmailExists: "このメールアドレスのユーザーが既に存在します",
  userActivated: "ユーザーを有効にしました",
  userDeactivated: "ユーザーを無効にしました",
  userStatusUpdateFailed: "ユーザーステータスの更新に失敗しました",
  editUserTitle: "ユーザー情報の編集",
  userUpdated: "ユーザー情報を更新しました",
  userUpdateFailed: "ユーザー情報の更新に失敗しました",
  resetPassword: "パスワード再設定",
  resetPasswordTitle: "パスワードの再設定",
  newPassword: "新しいパスワード",
  confirmPassword: "新しいパスワード（確認）",
  passwordMismatch: "パスワードが一致しません",
  passwordTooShort: "パスワードは8文字以上で入力してください",
  passwordTooLong: "パスワードは72文字以内で入力してください",
  passwordResetDone: "パスワードを再設定しました",
  passwordResetFailed: "パスワードの再設定に失敗しました",
  userNoLoginAccount: "この顧客にはログインアカウントがありません",
  dashboardAccount: "管理者アカウント",
  dashboardAccountLocked: "管理者アカウントは顧客画面から変更できません",
  deactivateUserConfirm: "このユーザーを無効にしますか？ログインできなくなります。",
  selectService: "サービスを選択",
  selectStaff: "スタッフを選択",
  selectUser: "ユーザーを選択",
  searchUser: "ユーザーを検索...",
  newUser: "新規ユーザー",
  userName: "ユーザー名",
  userPhone: "電話番号",
  bookingNotes: "メモ",
  viewFullNote: "全文",
  bookingCreated: "予約を作成しました",
  bookingCreateFailed: "予約の作成に失敗しました",
  selectTime: "時間を選択",
  eventLogs: "イベントログ",
  allActions: "すべてのアクション",
  allTypes: "すべてのタイプ",
  allActors: "すべての実行者",
  clear: "クリア",
  eventCount: "{count}件のイベント",
  noLogsFound: "ログが見つかりません",
  thAction: "アクション",
  thActor: "実行者",
  thTarget: "対象",
  thDetails: "詳細",
  groupAuth: "認証",
  groupBookings: "予約",
  groupServices: "サービス",
  groupStaff: "スタッフ",
  groupUsers: "ユーザー",
  groupSettings: "設定",
  groupMessages: "メッセージ",
  groupMail: "メール",
  targetAuth: "認証",
  targetBooking: "予約",
  targetService: "サービス",
  targetStaff: "スタッフ",
  targetUser: "ユーザー",
  targetCompany: "店舗",
  targetConversation: "会話",
  targetMailThread: "メールスレッド",
  targetReschedule: "予約変更",
  actorAdmin: "管理者",
  actorSystem: "システム",
  actionAuthLoginSuccess: "ログイン成功",
  actionAuthLoginFailed: "ログイン失敗",
  actionAuthAccessDenied: "アクセス拒否",
  actionBookingCreated: "予約作成",
  actionBookingCancelled: "予約キャンセル",
  actionBookingRescheduled: "予約変更",
  actionBookingConfirmed: "予約確認",
  actionBookingCompleted: "予約完了",
  actionBookingNoShow: "無断キャンセル",
  actionBookingStatusUpdated: "ステータス更新",
  actionServiceCreated: "サービス作成",
  actionServiceUpdated: "サービス更新",
  actionServiceDeactivated: "サービス無効化",
  actionServiceActivated: "サービス有効化",
  actionStaffCreated: "スタッフ作成",
  actionStaffUpdated: "スタッフ更新",
  actionStaffDeactivated: "スタッフ無効化",
  actionStaffActivated: "スタッフ有効化",
  actionStaffReordered: "スタッフ並び替え",
  actionScheduleUpdated: "スケジュール更新",
  actionUnavailabilityAdded: "不在追加",
  actionUnavailabilityRemoved: "不在削除",
  actionUserCreated: "ユーザー作成",
  actionUserRegistered: "ユーザー登録",
  actionUserUpdated: "ユーザー更新",
  actionUserActivated: "ユーザー有効化",
  actionUserDeactivated: "ユーザー無効化",
  actionUserPasswordReset: "パスワード再設定",
  actionAuthSyncFailed: "認証サービス同期エラー",
  actionSettingsUpdated: "設定更新",
  actionLineFollow: "LINE 友だち追加",
  actionLineUnfollow: "LINE 友だち解除",
  actionLineMessageReceived: "LINE メッセージ受信",
  actionLineAutoReplySent: "LINE 自動返信",
  actionLineMessageSent: "LINE 返信",
  actionLineQuotaExceeded: "LINE 上限超過",
  actionConversationDeleted: "会話削除",
  actionMailMessageSent: "メール送信",
  actionMailThreadDeleted: "メールスレッド削除",
  actionBookingDeleted: "予約削除",
  actionRescheduleDeleted: "予約変更削除",
  actionUserDeleted: "ユーザー削除",
  logAuthLoginSuccess: "{name}（{email}）が{source}でログインしました",
  logAuthLoginFailed: "{source}でのログイン失敗：{error}",
  logAuthAccessDenied: "{email}のアクセス拒否 — {reason}{role}",
  unverifiedSuffix: "(未検証)",
  logBookingCreated: "{actor}が{user}の予約を作成しました — {service}・{staff}・{time}",
  logBookingCancelled: "{actor}が{user}の予約をキャンセルしました — {service}・{staff}",
  logBookingRescheduled: "{actor}が{user}の予約を変更しました — {service}・{staff}：{oldDate} {oldTime} → {newDate} {newTime}",
  logBookingConfirmed: "{actor}が{user}の予約を確定しました — {service}・{staff}・{time}",
  logBookingCompleted: "{actor}が{user}の予約を完了しました — {service}・{staff}・{time}",
  logBookingNoShow: "{actor}が{user}を不来にしました — {service}・{staff}・{time}",
  logBookingStatusUpdated: "{actor}が{user}の予約ステータスを変更しました：{oldStatus} → {newStatus}",
  logServiceCreated: "{actor}がサービス「{name}」を作成しました（{duration}分・¥{price}）",
  logServiceUpdated: "{actor}がサービス「{name}」を更新しました",
  logServiceDeactivated: "{actor}がサービス「{name}」を無効化しました",
  logServiceActivated: "{actor}がサービス「{name}」を有効化しました",
  logStaffCreated: "{actor}がスタッフ「{name}」を追加しました",
  logStaffUpdated: "{actor}がスタッフ「{name}」を更新しました",
  logStaffDeactivated: "{actor}がスタッフ「{name}」を無効化しました",
  logStaffActivated: "{actor}がスタッフ「{name}」を有効化しました",
  logStaffReordered: "{actor}がスタッフの並び順を変更しました",
  logScheduleUpdated: "{actor}がスケジュールを更新しました：{details}",
  logUnavailabilityAdded: "{actor}が不在を追加しました：{details}",
  logUnavailabilityRemoved: "{actor}が不在を削除しました：{details}",
  logUserCreated: "{actor}がユーザー「{name}」を作成しました（{email}）",
  logUserRegistered: "{name}さんが登録しました",
  logUserUpdated: "{actor}がユーザー「{name}」を更新しました：{fields}",
  logUserActivated: "{actor}がユーザー「{name}」を有効化しました",
  logUserDeactivated: "{actor}がユーザー「{name}」を無効化しました",
  logUserPasswordReset: "{actor}がユーザー「{name}」のパスワードを再設定しました",
  logAuthSyncFailed: "認証サービスへの{operation}同期に失敗しました：{error}",
  logSettingsUpdated: "{actor}が設定を更新しました：{fields}",
  logLineFollow: "{actor}さんがLINEで友だち追加しました",
  logLineUnfollow: "{actor}さんがLINEの友だちを解除しました",
  logLineMessageReceived: "{actor}さんからLINEメッセージを受信しました",
  logLineAutoReplySent: "{actor}が自動返信を送信しました",
  logLineMessageSent: "{actor}がLINEで返信しました",
  logLineQuotaExceeded: "{actor}：LINE送信上限を超過 — リマインダー未送信",
  logConversationDeleted: "{actor}が会話を削除しました",
  logMailMessageSent: "{actor}がメールを送信しました",
  logMailThreadDeleted: "{actor}がメールスレッドを削除しました",
  logBookingDeleted: "{actor}が予約を削除しました — {user}・{service}・{staff}",
  logRescheduleDeleted: "{actor}が予約変更リクエストを削除しました — {user}・{service}・{staff}",
  logUserDeleted: "{actor}が顧客「{name}」を削除しました",
  logMetaAuth: "認証",
  logMetaBooking: "予約 #{id}",
  logMetaService: "サービス #{id}",
  logMetaStaff: "スタッフ #{id}",
  logMetaUser: "ユーザー #{id}",
  logMetaCompany: "店舗",
  logMetaConversation: "会話 #{id}",
  logMetaMailThread: "メールスレッド #{id}",
  logMetaReschedule: "予約変更 #{id}",

  messages: "LINEメッセージ",
  messagesTitle: "LINEメッセージ",
  messagesEmpty: "メッセージはまだありません。LINEリンクを顧客と共有しましょう！",
  inbox: "受信箱",
  unread: "未読",
  replyPlaceholder: "返信を入力...",
  send: "送信",
  sending: "送信中...",
  noConversationSelected: "会話を選択してください",
  unknownCustomer: "名前未設定",
  customerInfo: "顧客情報",
  recentBookings: "最近の予約",
  statusOpen: "対応中",
  statusPending: "保留",
  statusClosed: "完了",
  customerUnreachable: "この顧客はLINEでメッセージを受信できません（ブロックまたは友達解除）",
  lineQuotaExceeded: "LINEの月間メッセージ上限に達しました。時間をおいて再度お試しください。",
  lineQuotaRemaining: "LINE 残り送信枠: {remaining} / {total}",
  lineQuotaUnlimited: "LINE送信枠: 無制限",
  linePlanLimited: "制限プラン",
  linePlanUnlimited: "無制限",
  lineQuotaInline: "{plan} · {used}/{total} ({percent}%)",
  lineQuotaInlineUnlimited: "{plan} · 今月 {used}件",
  lineNotConfigured: "LINE未設定",
  lineQuotaTitle: "LINE メッセージ利用状況",
  messageSent: "送信しました",
  messageFailed: "送信に失敗しました。もう一度お試しください",
  searchPlaceholder: "顧客名やメッセージで検索...",
  filterAll: "すべて",
  filterOpen: "対応中",
  filterPending: "保留",
  filterClosed: "完了",
  filterUnassigned: "未対応",
  filterAssignedMe: "自分の担当",
  filterByStatus: "フィルター",
  noBookings: "予約履歴なし",
  openInMessages: "メッセージで開く",
  viewFullDetails: "詳細を表示",
  service: "メニュー",
  colDate: "日付",
  colTime: "時間",
  bookingHistory: "予約履歴",
  noMessagesYet: "メッセージの履歴はまだありません",
  activityLog: "アクティビティ履歴",
  noActivity: "履歴はありません",
  assignTo: "担当者",
  retry: "再送",
  stickerAlt: "スタンプ",
  memberSince: "登録日",
  lineId: "LINE ID",
  notProvided: "—",

  // --- Shared features (webmail, hard-delete, staff notify/reorder, one-time) ---
  bookingDeleted: "予約を削除しました",
  conversationDeleted: "会話を削除しました",
  crossOff: "受付停止",
  crossOffTitle: "この時間を空けない設定にする",
  crossOffUntil: "終了時間",
  crossOffReason: "メモ（任意）",
  crossOffReasonPlaceholder: "例：休憩",
  existingCustomer: "既存のお客様",
  noteOnly: "メモのみ",
  noteOnlyHint: "お客様を登録せずに、この枠をメモ付きで予約します。予約一覧には確定済みの予約として表示されます。",
  noteRequired: "お客様を選ばない場合はメモが必須です",
  crossOffHint: "空き枠をクリックすると受付停止、停止中の枠をクリックすると受付再開します。",
  crossedOff: "受付停止中",
  restoreSlotConfirm: "この枠の受付を再開しますか？予約可能に戻り、メモは削除されます。",
  pastDateCannotChange: "過去の日付は変更できません。",
  customerDeleted: "顧客を削除しました",
  delete: "削除",
  deleteBookingConfirm: "この予約を完全に削除しますか？枠が解放され、元に戻せません。",
  deleteConversationConfirm: "この会話とすべてのメッセージを完全に削除しますか？元に戻せません。",
  deleteCustomerConfirm: "この顧客を完全に削除しますか？予約や会話も削除されます。元に戻せません。",
  deleteMailConfirm: "このメールスレッドを完全に削除しますか？元に戻せません。",
  deleteRescheduleConfirm: "この変更履歴を削除しますか？予約の日時は変わりません。元に戻せません。",
  dragToReorderHint: "ドラッグして並び替え",
  emailHint: "予約通知を送るメールアドレス",
  emailNotify: "メール通知",
  lineIdHint: "予約通知を送るLINEユーザーID",
  staffLinkUser: "顧客情報と紐付け",
  staffUnlink: "紐付けを解除",
  staffLinkUserHint: "顧客を検索すると、その情報からLINE IDとメールアドレス欄に入力されます。",
  lineNotify: "LINE通知",
  mail: "メール",
  mailAllInboxes: "すべて",
  mailDeleted: "メールスレッドを削除しました",
  mailFilter_all: "すべて",
  mailFilter_closed: "完了",
  mailFilter_open: "対応中",
  mailFilter_pending: "保留",
  mailLinkedCustomer: "顧客",
  mailLoadFailed: "メールの読み込みに失敗しました",
  mailNoLinkedCustomer: "紐づく顧客なし",
  mailNoMailboxes: "メールボックスが未設定です。設定 → メール から追加してください。",
  mailNoSubject: "（件名なし）",
  mailNoThreadSelected: "メールを選択してください",
  mailNoThreads: "メールはありません",
  mailSearchPlaceholder: "メールを検索…",
  mailSendFailed: "返信の送信に失敗しました",
  dateRequired: "日付を選択してください",
  assignFailed: "担当者の変更に失敗しました",
  statusUpdateFailed: "ステータスの更新に失敗しました",
  mailStatusUpdateFailed: "ステータスの更新に失敗しました",
  mailSent: "返信を送信しました",
  mailSettings: "メール",
  mailStaff: "スタッフ",
  mailStatusLabel: "ステータス",
  mailStatus_closed: "完了",
  mailStatus_open: "対応中",
  mailStatus_pending: "保留",
  mailTitle: "メール",
  mailCompose: "新規作成",
  mailComposeTitle: "新規メール",
  mailFrom: "差出人",
  mailTo: "宛先",
  mailSubject: "件名",
  mailBody: "本文",
  mailComposeSent: "メールを送信しました",
  goToMailPage: "メールページへ",
  mailUnknownCustomer: "不明な顧客",
  mailboxActive: "有効（この受信箱を取得）",
  mailboxAdd: "メールボックスを追加",
  mailboxDeleteConfirm: "メールボックス {email} を削除しますか？保存済みのスレッドも削除されます。",
  mailboxEdit: "メールボックスを編集",
  mailboxEmail: "メールアドレス",
  mailboxEncNone: "なし",
  mailboxEncryption: "暗号化",
  mailboxError: "取得エラー",
  mailboxFromName: "送信者名",
  mailboxImapHost: "IMAPホスト",
  mailboxImapPassword: "IMAPパスワード",
  mailboxImapPort: "IMAPポート",
  mailboxImapUser: "IMAPユーザー名",
  mailboxInactive: "無効",
  mailboxLabel: "ラベル",
  mailboxPasswordKeep: "変更しない場合は空欄",
  mailboxSaved: "メールボックスを保存しました",
  mailboxesDesc: "IMAPで受信し、メール受信箱に表示されるメールボックスです。1つ以上追加できます。",
  mailboxesEmpty: "メールボックスがありません。",
  mailboxesTitle: "メールボックス",
  noBookingsForStaff: "この日はこのスタッフの予約はありません。",
  notifyFromDefault: "既定（サービスの既定送信元）",
  notifyFromDesc: "予約通知メールはこのアドレスから送信され、お客様の返信はこの受信箱に届きます。",
  notifyFromSaved: "送信元を保存しました",
  notifyFromTitle: "通知メールの送信元",
  oneTimeOnly: "初回のみ",
  oneTimeOnlyHint: "各お客様は一度のみ予約できます",
  profilePhoto: "プロフィール写真",
  removePhoto: "写真を削除",
  reorderFailed: "並び順を保存できませんでした",
  rescheduleDeleted: "変更履歴を削除しました",
  restore: "受付再開",
  save: "保存",
  selectStaffToManage: "枠を管理するスタッフを選択してください。",
  staffNotWorking: "このスタッフはこの日は勤務していません。",
  thReorder: "並び順",

  // --- Gym memberships ---
  plans: "プラン",
  // The staff edit modal's プラン checkboxes (StaffLinkSection). Defined only
  // here: clinic and fudousan register no section, so the keys are unreachable
  // there and t() would fall through to the key name anyway.
  staffLinks: "担当サービス",
  staffLinksHint: "選択したサービスの予約でのみ、このスタッフが担当者として表示されます。",
  staffLinksNone: "サービスが未選択です。このスタッフは予約できません。",
  staffLinksSaveFailed: "スタッフは保存しましたが、担当サービスの保存に失敗しました。",
  addPlan: "プランを追加",
  addPlanTitle: "プランを追加",
  editPlanTitle: "プランを編集",
  noPlansYet: "プランがまだありません",
  deactivatePlanConfirm:
    "このプランを無効にしますか？既存の会員パスとの紐付けは残りますが、カタログには表示されなくなります。",
  thSessionType: "セッション種別",
  thCapacity: "定員",
  thQuota: "回数",
  thValidityDays: "有効期間（日）",
  validityHint: "空欄の場合は無期限（都度払い）。",
  planCode: "プランコード",
  planCodeHint: "外部リンク用の任意の一意なスラッグ（例: 4x-personal）。",
  oneTimeOnlyLabel: "1回限り（体験・初回限定プラン）",
  planIssued: "発行済み",

  memberships: "会員パス",
  issueMembership: "会員パスを発行",
  issueMembershipTitle: "会員パスを発行",
  fulfill: "対応する",
  decline: "却下",
  fulfillRequestTitle: "ご予約に対応",
  declineRequestConfirm: "この予約を却下しますか？",
  deleteRequestConfirm: "この予約を削除しますか？この操作は取り消せません。",
  deleteMembershipConfirm: "この会員権を削除しますか？この操作は取り消せません。",
  statusDeclined: "却下済み",
  noMembershipsYet: "発行済みの会員パスはまだありません",
  thMember: "会員",
  thPlan: "プラン",
  thRemaining: "残り回数",
  thExpires: "有効期限",
  thPurchased: "購入日",
  thPaid: "支払額",
  selectMember: "会員",
  selectPlan: "プラン",
  paymentMethod: "支払方法",
  amountPaid: "支払額",
  amountPaidHint: "空欄の場合はプラン料金を使用します。",
  partnerName: "ペアのお相手",
  partnerNameHint: "ペアプランのお相手のお名前（アカウント不要）。",
  pairWithBadge: "ペア: {name}",
  methodCash: "現金",
  methodCard: "カード",
  methodLinePay: "LINE Pay",
  methodOther: "その他",
  issue: "発行",
  adjustMembership: "調整",
  adjustMembershipTitle: "会員パスを調整",
  newRemaining: "残り回数",
  oneTimeNoAdjustHint: "お一人様1回限りのプランは残り回数を変更できません。",
  newExpiry: "有効期限",
  cancelMembershipAction: "解約",
  confirmCancelMembership: "この会員パスを解約しますか？残り回数は使用できなくなります。",
  reactivate: "再有効化",
  statusActiveLabel: "有効",
  statusExhausted: "消化済み",
  statusExpired: "期限切れ",
  statusCancelled: "解約済み",
  rptActiveMembers: "有効会員数",
  rptOutstanding: "残セッション合計",
  rptRevenue: "売上",
  rptSessionsUsed: "消化セッション",
  rptPurchases: "購入件数",

  membershipIssued: "会員パスを発行しました",
  requestFulfilled: "ご予約に対応しました",
  membershipAdjusted: "会員パスを更新しました",
  membershipCancelled: "会員パスを解約しました",
  membershipReactivated: "会員パスを再有効化しました",
  requestDeclined: "予約を却下しました",
  requestDeleted: "予約を削除しました",
  membershipDeleted: "会員パスを削除しました",
  planCreated: "プランを追加しました",
  planUpdated: "プランを更新しました",
  planActivated: "プランを有効にしました",
  planDeactivated: "プランを無効にしました",

  // b2
  mailboxDeleted: "メールボックスを削除しました",

  // b3
  loadFailed: "読み込みに失敗しました。",
  reconnecting: "再接続中...",
  mainNavigation: "メインナビゲーション",
  menu: "メニュー",
  skipToContent: "本文へスキップ",

  // b4
  today: "今日",
  jumpToMonth: "月を選択",
  // Blog — admin/staff authoring.
  blog: "ブログ",
  newPost: "記事を作成",
  editPost: "記事を編集",
  postTitle: "タイトル",
  postBody: "本文",
  postStatus: "公開状態",
  postDate: "日付",
  postTags: "タグ",
  postTagsHint: "#タグを入力してスペースで追加（投稿に表示されます）",
  categoryPlaceholder: "例: お知らせ",
  blogFilterCategories: "カテゴリー",
  blogFilterTags: "タグ",
  blogFilterAll: "すべて",
  manageCategories: "カテゴリーを管理",
  editCategory: "カテゴリーを編集",
  addCategory: "追加",
  movePostsTo: "投稿の移動先",
  uncategorised: "未分類",
  deleteCategoryConfirm: "カテゴリー「{name}」を削除しますか？{count}件の投稿が影響を受けます。",
  viewPost: "表示",
  draft: "下書き",
  published: "公開済み",
  postSaved: "記事を保存しました",
  deletePost: "削除",
  deletePostConfirm: "この記事を完全に削除しますか？元に戻せません。",
  postDeleted: "記事を削除しました",
  uploadImageFailed: "画像のアップロードに失敗しました",
  noPostsYet: "記事はまだありません",
  noPostsFound: "検索に一致する記事はありません。",
  searchBlogPosts: "タイトル・著者・カテゴリー・タグで検索...",
  blogPostCount: "{count} 件の記事",
  thAuthor: "投稿者",
  thPublishedAt: "公開日時",
  thUpdatedAt: "更新日時",
  bold: "太字",
  italic: "斜体",
  bulletList: "箇条書き",
  orderedList: "番号付きリスト",
  setLink: "リンク",
  linkUrl: "リンク先URL",
  insertImage: "画像を挿入",
  undo: "元に戻す",
  redo: "やり直す",
  // UI/UX pass, 2026-10-08
  roleSuperAdmin: "スーパー管理者",
  roleAdmin: "管理者",
  roleStaff: "スタッフ",
  lineOnly: "LINEのみ",
  showLoginEvents: "ログインも表示",
  unreadLine: "未読LINE",
  unreadMail: "未読メール",
  upcomingWeek: "今後7日間の予約",
  noUpcomingWeek: "今後7日間の予約はありません",
  chooseImage: "画像を選択",
  // One admin for a clinic and a gym (teisyovision plan.md phase 13).
  staffPlanLinks: "担当プラン",
  staffPlanLinksHint: "選択したプランをお持ちの会員にのみ、このスタッフが予約可能なトレーナーとして表示されます。",
  staffPlanLinksNone: "プランが未選択です。このスタッフは予約できません。",
  staffPlanLinksSaveFailed: "スタッフは保存しましたが、担当プランの保存に失敗しました。",
  navGroupClinic: "整骨院",
  navGroupGym: "ジム",
  lineAll: "全て",
  lineSwitch: "表示する事業",
  navGroupAdmin: "管理",
  thKind: "区分",
  kindAll: "すべて",
  kindClinic: "整骨院",
  kindGym: "ジム",
  serviceKindHint: "ジムのセッション種別は、会員プランを通してのみ予約できます。",
  openingSpecialScope: "対象",
  openingSpecialScopeHint: "特別価格を適用するメニューやプランを選びます。",
  scopeAll: "すべて（整骨院とジム）",
  scopeClinic: "整骨院のメニューすべて",
  scopeGym: "ジムのセッションとプランすべて",
  scopeService: "メニュー：{name}",
  scopePlan: "プラン：{name}",
};
export default ja;

